import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import breeder from './assets/breeder.svg';
import buyer from './assets/buyer.svg';
import educator from './assets/educator.svg';
import groomer from './assets/groomer.svg';
import shelter from './assets/shelter.svg';
import vet from './assets/vet.svg';
import * as Styled from './styled';
import type { JoinBannerProps } from './types';

export * from './types';

export const JoinBanner: FC<JoinBannerProps> = (props) => {
  const { vetLink, groomerLink, buyerLink, breederLink, shelterLink, educatorLink } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <Styled.ItemWrapper to={buyerLink}>
        <Styled.ItemImage src={buyer} />
        <Styled.ItemTitle>{translate('glossary.adoptant')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
      <Styled.ItemWrapper to={breederLink}>
        <Styled.ItemImage src={breeder} />
        <Styled.ItemTitle>{translate('glossary.breeder')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
      <Styled.ItemWrapper to={shelterLink}>
        <Styled.ItemImage src={shelter} />
        <Styled.ItemTitle>{translate('glossary.shelter')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
      <Styled.ItemWrapper to={vetLink}>
        <Styled.ItemImage src={vet} />
        <Styled.ItemTitle>{translate('glossary.vet')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
      <Styled.ItemWrapper to={groomerLink}>
        <Styled.ItemImage src={groomer} />
        <Styled.ItemTitle>{translate('glossary.groomer')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
      <Styled.ItemWrapper to={educatorLink}>
        <Styled.ItemImage src={educator} />
        <Styled.ItemTitle>{translate('glossary.educator')}</Styled.ItemTitle>
        <Styled.ItemButton color="blue">{translate('common.buttons.iRegister')}</Styled.ItemButton>
      </Styled.ItemWrapper>
    </Styled.Wrapper>
  );
};
